'use strict';

var React = require('react');

var SvgIncomingMajor = function SvgIncomingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-10a1.5 1.5 0 0 1 1.5-1.5h4.5v2h-4v9h14v-9h-4v-2h4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2a1 1 0 0 1 0-2h5c2.757 0 5 2.243 5 5v6.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a.998.998 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l1.293 1.293v-6.586c0-1.654-1.346-3-3-3h-5z"
  }));
};

exports.SvgIncomingMajor = SvgIncomingMajor;
